import { useEffect } from 'react';

export enum ScriptEnvironments {
  DEVELOPMENT = 'DEVELOPMENT',
  PRODUCTION = 'PRODUCTION',
}

const useScript = ({
  url,
  functionText,
  id,
  integrity,
  async = true,
  environments = [ScriptEnvironments.DEVELOPMENT, ScriptEnvironments.PRODUCTION],
  crossOrigin = 'strict',
  defer = true,
  addToHead = false,
  type = 'text/javascript',
}: {
  url?: string;
  functionText?: string;
  id: string;
  integrity?: any;
  async?: boolean;
  environments?: ScriptEnvironments[];
  crossOrigin?: string;
  defer?: boolean;
  addToHead?: boolean;
  type?: string | null;
}) => {
  useEffect(() => {
    // Check if the current environment is in the list of specified environments
    if (!environments.includes(process.env.REACT_APP_ENVTYPE as ScriptEnvironments)) {
      return;
    }

    if (!url && !functionText) {
      console.error('You need to provide either a url or a functionText to a script');
      return;
    }

    const script = document.createElement('script');
    if (url) {
      script.src = url;
    }
    if (functionText) {
      script.text = functionText;
    }
    script.defer = defer;
    script.async = async;
    script.id = id;

    if (type !== null) {
      script.type = type;
    }

    if (integrity) {
      script.integrity = integrity;
    }

    if (crossOrigin) {
      script.crossOrigin = crossOrigin;
    }

    const parent = addToHead ? document.head || document.getElementsByTagName('head')[0] : document.body;
    parent.appendChild(script);

    return () => {
      if (script.parentNode === parent) {
        parent.removeChild(script);
      }
    };
  }, [url, functionText, integrity, async, crossOrigin]);
};

export default useScript;
